import React, { useEffect } from "react";
import { Autocomplete } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
import RowLabel from "./RowLabel";
import ColumnLabel from "./ColumnLabel";
import { CssTextField } from "./CssTextField";
import { Stack } from "@mui/material";
import { useSelector } from "react-redux";

const BaseAutoComplete = (props) => {
  const { formState } = useFormContext();
  const { fieldsVariant } = useSelector((state) => state.customization);
  const {
    name,
    field,
    valueName = "value",
    labelName = "label",
    options = [],
    label,
    rowDirection = false,

    disableClearable = false,
    disablePortal = true,
    customChangeFn = () => {},
    placeholder,
    fixedPadding = 8,
    fullWidth = true,
    ...other
  } = props;

  const { value, onChange } = field;
  const { errors } = formState;

  const getOptionLabel = (option) => option[labelName] ?? "";
  const isOptionEqualToValue = (option, value) =>
    option[valueName] === value?.[valueName];

  return (
    <Stack direction={rowDirection ? "row" : "column"} spacing={1}>
      {fieldsVariant === "standard" &&
        (rowDirection ? (
          <RowLabel label={label} />
        ) : (
          <ColumnLabel label={label} />
        ))}

      <Autocomplete
        noOptionsText="Δεν βρέθηκαν αποτελέσματα"
        disablePortal={disablePortal}
        options={options}
        value={value || null}
        isOptionEqualToValue={isOptionEqualToValue}
        getOptionLabel={getOptionLabel}
        onChange={(_, newValue) => {
          onChange(newValue);
          customChangeFn(newValue);
        }}
        fullWidth={fullWidth}
        disableClearable={disableClearable}
        renderInput={(params) => (
          <CssTextField
            {...params}
            label={fieldsVariant === "standard" ? null : label}
            error={!!errors[name]}
            helperText={errors[name]?.message}
            variant={fieldsVariant}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
            }}
            size="small"
            fixedPadding={fixedPadding}
            placeholder={placeholder}
          />
        )}
        {...other}
      />
    </Stack>
  );
};

const ClientAutocomplete = (props) => {
  const { control, setValue } = useFormContext();
  const {
    name,
    rules,
    valueName,
    labelName,
    defaultValue = null,
    options,
    customChangeFn,
    defaultFromProps = true,
    ...other
  } = props;

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState }) => (
        <BaseAutoComplete
          customChangeFn={customChangeFn}
          name={name}
          valueName={valueName}
          labelName={labelName}
          field={{
            ...field,
            value:
              options.find((opt) => opt[valueName] === field.value) || null, // for controlled display
            onChange: (option) => field.onChange(option?.[valueName] ?? null), // store only value
          }}
          options={options}
          {...other}
        />
      )}
    />
  );
};

export default ClientAutocomplete;
